import type { FemaMessageDisplayState } from 'types/femaMessage.types';

/** Bootstrap badge variant per display state — failed and cancelled both read as a stop condition. */
export const FEMA_STATE_BADGE_VARIANT: Record<FemaMessageDisplayState, string> = {
  sent: 'success',
  updated: 'info',
  cancelled: 'secondary',
  expired: 'dark',
  failed: 'danger',
};

export const FEMA_STATE_LABEL: Record<FemaMessageDisplayState, string> = {
  sent: 'Sent',
  updated: 'Updated',
  cancelled: 'Cancelled',
  expired: 'Expired',
  failed: 'Failed to send',
};
